/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Preferedfirstsubject2Inputs */

const de__field_preferedfirstsubject2 = /** @type {(inputs: _Field_Preferedfirstsubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugtes Erstfach`)
};

/**

* @param {_Field_Preferedfirstsubject2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_preferedfirstsubject2 = /** @type {((inputs?: _Field_Preferedfirstsubject2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Preferedfirstsubject2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_preferedfirstsubject2(inputs)
});
export { _field_preferedfirstsubject2 as "_field_preferedFirstSubject" }